import { http } from '../../services/http';
import type { ApiMeta } from '../../types/api';

export const systemApi = {
  meta: (signal?: AbortSignal) => http.get<ApiMeta>('/meta', signal ? { signal } : undefined),
};
